import React, { Suspense } from 'react';
import { PostList } from '../lazyComponents';

const PostRow = (props) => {
    const {
        noPostsText,
        postLinkType,
        postCategoryHeadingLevel,
        posts,
        postTitleHeadingLevel,
        maxPosts,
    } = props;

    return (
        <Suspense fallback={''}>
            <PostList
                noPostsText={noPostsText}
                postLinkType={postLinkType}
                postCategoryHeadingLevel={postCategoryHeadingLevel}
                posts={posts ? posts.slice(0, maxPosts) : []}
                postTitleHeadingLevel={postTitleHeadingLevel}
                carrousel={maxPosts > 3 ? true : false}
            />
        </Suspense>
    );
};

PostRow.displayName = 'PostRow';

PostRow.defaultProps = {
    maxPosts: 3,
};

export default PostRow;
